export enum PermissionList {
  PERMISSION_EDIT = 'permission.edit',

  MODELS_VIEW = 'models.view',

  COMPANIES_VIEW = 'companies.view',

  BUILDINGS_VIEW = 'buildings.view',

  LOCATIONS_VIEW = 'locations.view',

  ACCOUNTS_VIEW = 'counters.view',

  RATES_VIEW = 'rates.view',

  COUNTERS_VIEW = 'counters.view',

  COUNTERS_DATA_VIEW = 'counters.data.view',
}
